/* ==========================================================================
   Página de producto — Estilo Biomedicalli
   <bm-buy-box>: subtotal (precio × cantidad) y formulario "Comprar ahora".
   <bm-media-caption>: texto e índice de la imagen activa junto a las miniaturas.
   No cambia la lógica del carrito: "Agregar al carrito" sigue siendo
   <product-form> (product-form.js) y "Comprar ahora" es un formulario nativo
   de Shopify a /cart/add con return_to=/checkout.
   ========================================================================== */

(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';

    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const template = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }

    const match = template.match(placeholder);
    if (!match) return template;

    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return template.replace(placeholder, value);
  }

  if (!customElements.get('bm-buy-box')) {
    customElements.define(
      'bm-buy-box',
      class BmBuyBox extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.quantityInput = document.getElementById(`Quantity-${this.sectionId}`);
          this.subtotalLabel = this.querySelector('[data-bm-subtotal-label]');
          this.subtotalValue = this.querySelector('[data-bm-subtotal-value]');
          this.buyNowForm = this.querySelector('[data-bm-buy-now]');

          this.onQuantityChange = this.update.bind(this);
          if (this.quantityInput) {
            this.quantityInput.addEventListener('change', this.onQuantityChange);
            this.quantityInput.addEventListener('input', this.onQuantityChange);
          }

          if (this.buyNowForm) {
            this.buyNowForm.addEventListener('submit', () => {
              const quantity = this.buyNowForm.querySelector('input[name="quantity"]');
              if (quantity) quantity.value = this.getQuantity();
            });
          }

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribers = [
              subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (!event || !event.data || event.data.sectionId !== this.sectionId) return;
                this.onVariantChange(event.data.variant);
              }),
              subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.update()),
            ];
          }

          this.update();
        }

        disconnectedCallback() {
          if (this.quantityInput) {
            this.quantityInput.removeEventListener('change', this.onQuantityChange);
            this.quantityInput.removeEventListener('input', this.onQuantityChange);
          }
          (this.unsubscribers || []).forEach((unsubscribe) => unsubscribe());
        }

        getQuantity() {
          const value = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
          return isNaN(value) || value < 1 ? 1 : value;
        }

        getUnitPrice() {
          // El precio vive dentro de #price-{sección}, que global.js reemplaza al cambiar de variante.
          const priceElement = this.querySelector('[data-bm-price]');
          return priceElement ? parseInt(priceElement.dataset.bmPrice, 10) : NaN;
        }

        onVariantChange(variant) {
          if (variant && this.buyNowForm) {
            const idInput = this.buyNowForm.querySelector('input[name="id"]');
            const button = this.buyNowForm.querySelector('button[type="submit"]');
            if (idInput) idInput.value = variant.id;
            if (button) button.toggleAttribute('disabled', !variant.available);
          }
          this.update();
        }

        update() {
          const quantity = this.getQuantity();
          const price = this.getUnitPrice();

          if (this.subtotalLabel) {
            const unit = quantity === 1 ? this.dataset.unitOne : this.dataset.unitMany;
            this.subtotalLabel.textContent = unit ? `(${quantity} ${unit})` : `(${quantity})`;
          }

          if (this.subtotalValue && !isNaN(price)) {
            this.subtotalValue.textContent = formatMoney(price * quantity, this.dataset.moneyFormat);
          }
        }
      }
    );
  }

  if (!customElements.get('bm-media-caption')) {
    customElements.define(
      'bm-media-caption',
      class BmMediaCaption extends HTMLElement {
        connectedCallback() {
          this.thumbnails = document.getElementById(this.dataset.thumbnails);
          if (!this.thumbnails) return;

          this.observer = new MutationObserver(() => this.update());
          this.observer.observe(this.thumbnails, {
            attributes: true,
            attributeFilter: ['aria-current'],
            subtree: true,
            childList: true,
          });
          this.update();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        update() {
          const items = Array.from(this.thumbnails.querySelectorAll('.thumbnail-list__item')).filter(
            (item) => item.offsetParent !== null || !item.classList.contains('thumbnail-list_item--variant')
          );
          if (!items.length) return;

          let index = items.findIndex((item) => item.querySelector('[aria-current]'));
          if (index < 0) index = 0;

          const image = items[index].querySelector('img');
          const alt = image && !this.hasAttribute('data-no-alt') ? (image.getAttribute('alt') || '').trim() : '';
          const counter = (this.dataset.counter || '[index] de [count]')
            .replace('[index]', index + 1)
            .replace('[count]', items.length);

          this.textContent = alt ? `${alt} · ${counter}` : counter;
        }
      }
    );
  }
})();
